import { Link } from "react-router-dom"
import { deTabellen, sdTabellenCollection, userAdmin, userVci } from "../../constants/const";
import styled from "styled-components";


export default function SubMenu({ which, setSub }) {
    switch (which) {
        case "BK":
            return (
                <MenueCategoriesSub type="none" onMouseLeave={() => setSub()}>
                    {sessionStorage.getItem('token').includes(userAdmin) && <li><Link to="/kontenverwaltung">
                        <MenueCategoriesSubButton>&#8811; Kontenverwaltung</MenueCategoriesSubButton>
                    </Link></li>}
                    <li><Link to="/benutzerkonto">
                    <MenueCategoriesSubButton>&#8811; Passwort ändern</MenueCategoriesSubButton>
                    </Link></li>
                </MenueCategoriesSub>
            )
        case "SD":
            return (
                <MenueCategoriesSub type="none" onMouseLeave={() => setSub()}>
                    {sdTabellenCollection.map(tab => {
                        return (
                            <li key={tab.kurz}>
                                <Link to={`/stammdaten/${tab.kurz}`}>
                                    <MenueCategoriesSubButton >&#8811; {tab.header}</MenueCategoriesSubButton>
                                </Link>
                            </li>
                        )
                    })}
                </MenueCategoriesSub>
            );
        case "DE":
            return (
                <MenueCategoriesSub type="none" onMouseLeave={() => setSub()}>
                    {deTabellen.map(de => {
                        return (
                            <li key={de.kurz}>
                                <Link to={`/datenerfassung/${de.header.toLocaleLowerCase()}`}>
                                    <MenueCategoriesSubButton>&#8811; {de.header}</MenueCategoriesSubButton>
                                </Link>
                            </li>
                        )
                    })}
                    {sessionStorage.getItem('token').includes(userVci) && <li>
                        <Link to="/datenerfassung/neues-jahr">
                            <MenueCategoriesSubButton>&#8811; neues Jahr</MenueCategoriesSubButton>
                        </Link>
                    </li>}
                </MenueCategoriesSub>
            )
        case "REP":
            return (
                <MenueCategoriesSub type="none" onMouseLeave={() => setSub()}>
                    <li><Link to="/reporting/einwohner">
                        <MenueCategoriesSubButton>
                            &#8811; Einwohner
                        </MenueCategoriesSubButton>
                    </Link></li>
                    <li><Link to="/reporting/inframap">
                        <MenueCategoriesSubButton>
                            &#8811; Infra-Map
                        </MenueCategoriesSubButton>
                    </Link></li>
                    <li><Link to="/reporting/zugangsstellen">
                        <MenueCategoriesSubButton>
                            &#8811; Zugangsstellen
                        </MenueCategoriesSubButton>
                    </Link></li>
                </MenueCategoriesSub>
            )
        case "SUP":
            return (
                <MenueCategoriesSub type="none" onMouseLeave={() => setSub()}>
                    <li><MenueCategoriesSubButton disabled >
                        &#8811; Kontaktdaten vci
                    </MenueCategoriesSubButton></li>
                    <li><MenueCategoriesSubButton disabled >
                        &#8811; Kontakt admin
                    </MenueCategoriesSubButton></li>
                    <li><MenueCategoriesSubButton disabled >
                        &#8811; ?
                    </MenueCategoriesSubButton></li>
                </MenueCategoriesSub>
            )
        case "JK":
            return (
                <MenueCategoriesSub type="none" onMouseLeave={() => setSub()}>
                    <li><Link to="/jahreszahlen">
                        <MenueCategoriesSubButton>&#8811; Tagesgruppen &#38; Einwohner</MenueCategoriesSubButton>
                    </Link></li>
                </MenueCategoriesSub>
            )
        case "VB":
            return (
                <MenueCategoriesSub type="none" onMouseLeave={() => setSub()}>
                    <li><Link to="/aufgaben">
                        <MenueCategoriesSubButton>
                            &#8811; offene Aufgaben
                            </MenueCategoriesSubButton>
                    </Link></li>
                    <li><Link to="/notizen">
                        <MenueCategoriesSubButton>
                            &#8811; Notizen
                            </MenueCategoriesSubButton>
                    </Link></li>
                </MenueCategoriesSub>
            )
        default:
            <></>
    }
}

const MenueCategoriesSub = styled.ul`
    margin: 0em;
    padding: 0 0.5em;
    width: 17em;
    height: max-content;
    background-color: gainsboro;

    display: flex;
    flex-direction: column;

    position: absolute;
    left: 0; top: 100%;
`

const MenueCategoriesSubButton = styled.button`
    width: 100%;
    height: 2em;
    text-align: left;
    padding-left: 1em;
    background-color: gainsboro;
    border: none;
    border-bottom: 1px solid rgb(182, 182, 182); 
`